<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Alisha Ramasar is a unique hybrid of a sunshine-yellow and cool-blue-personality. She is an award-winning International Cannes Lion advertising agency recipient. She has the ability to conceptualise, visualise, optimise and quite frankly, kick some ass into gear. She is an innovator, a strategist, a fashionable-foodie-fanatic that loves to add something special to simply…‘doing’. She is a proud wife and a mummy of two princess-superhero girls who inspired this entire book. She aspires to take a break and rest, but somehow keeps on agreeing to do more sh*t that gets in the way of her taking a break and resting.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?35871ce6